'use client'

import { Share } from 'lucide-react'
import { useSelector } from 'react-redux'
import { RootState } from 'features/store'
import { toast } from 'react-toastify'
import { buildShareUrl } from '@/lib/sharing'

const IngredientShareButton = ({ ingredientId }: { ingredientId?: number | string | null }) => {
  const user = useSelector((state: RootState) => state.culineerAuth.user)

  return (
    <button
      type="button"
      onClick={() => {
        const shareUrl = buildShareUrl(window.location.pathname, 'ingredient', String(ingredientId), user?.slug)
        navigator.clipboard.writeText(shareUrl)
        toast.success('Link copied to clipboard!')
      }}
      className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-full border border-[#CBD7DD] bg-[#F7F7F7] px-4 text-base font-normal text-[#548828] transition-colors hover:bg-gray-100"
    >
      <Share size={20} color="#2E7D0F" />
      Share
    </button>
  )
}

export default IngredientShareButton
